export default "__VITE_ASSET__DPVzRrMI__"